import { useParams } from "react-router-dom";
import AppLayout from "@/layouts/AppLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { MobileFacilityOverview, MobileFacilityNavigation } from "@/components/MobileNavigationLandingPage";
import { useFacilityNavLinks } from "./_utils";

export default function MobileFacilityLandingPage() {
  const { facilityId } = useParams();
  const navLinks = useFacilityNavLinks(facilityId);

  if (!facilityId) {
    return null;
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      <Breadcrumb compactOnly compactTitle="Manage Facility" backLink={{ to: "/facilities" }} />
      <MobileFacilityOverview facilityId={facilityId} />
      <MobileFacilityNavigation facilityId={facilityId} />
    </AppLayout>
  );
}
